<template>
  <div class="tips">
    <h5>&emsp;绑定成功！</h5>
    <div class="img-box">
      <img class="img" src="@/assets/images/img-set_success.png" alt />
    </div>
    <div class="btn-box">
      <v-button @click="doRedirect">
        去到&ensp;{{targetUrl}}
        <span class="counting">{{time}}</span>
      </v-button>
    </div>
  </div>
</template>

<script>
import vButton from "./vButton.vue";
import { getUri } from "@/uitls/index";

import mixinRedirect from "../utils/mixinRedirect";

export default {
  components: {
    vButton
  },
  mixins: [mixinRedirect],
  data() {
    return {
      time: 2,
      targetUrl: "",
      timer: null
    };
  },
  methods: {},
  mounted() {
    let redirect = this.$route.query.redirect_url;

    if (redirect) {
      let uri = getUri(redirect);
      this.targetUrl = uri.hostname;
      // TODO: recognize uri and show related title
    } else {
      this.targetUrl = "账户详情";
    }

    this.timer = setInterval(() => {
      this.time--;
      if (this.time < 1) {
        this.doRedirect();
      }
    }, 1000);
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../styles/success.scss";
</style>



// WEBPACK FOOTER //
// src/views/index/components/bindS.vue